import React from "react";
import {
  SimpleShowLayout,
  TextField,
  NumberInput,
  TextInput
} from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="football.id" />
      <NumberInput source="football.seasonWins" />
      <NumberInput source="football.seasonLosses" />
      <NumberInput source="football.seasonTies" />
      <NumberInput source="football.seasonPercentWins" />
      <NumberInput source="football.districtWins" />
      <NumberInput source="football.districtLosses" />
      <NumberInput source="football.districtTies" />
      <NumberInput source="football.districtPercentWins" />
      <NumberInput source="football.homeWins" />
      <NumberInput source="football.homeLosses" />
      <NumberInput source="football.homeTies" />
      <NumberInput source="football.roadWins" />
      <NumberInput source="football.roadLosses" />
      <NumberInput source="football.roadTies" />
      <TextInput source="football.streak" />
      <NumberInput source="football.differential" />
      <NumberInput source="football.pointsFor" />
      <NumberInput source="football.pointsForPerGame" />
      <NumberInput source="football.totalYards" />
      <NumberInput source="football.totalYardsPerGame" />
      <NumberInput source="football.rushingYards" />
      <NumberInput source="football.rushingYardsPerGame" />
      <NumberInput source="football.passingYards" />
      <NumberInput source="football.passingYardsPerGame" />
      <NumberInput source="football.pointsAgainst" />
      <NumberInput source="football.pointsAgainstPerGame" />
      <NumberInput source="football.totalYardsAllowed" />
      <NumberInput source="football.totalYardsAllowedPerGame" />
      <NumberInput source="football.rushingYardsAllowed" />
      <NumberInput source="football.rushingYardsAllowedPerGame" />
      <NumberInput source="football.passingYardsAllowed" />
      <NumberInput source="football.passingYardsAllowedPerGame" />
    </SimpleShowLayout>
  );
};

export default FormTab;
